import { useSelector } from 'react-redux';

export function useIsProductInHighDemand(currentProduct = {}) {
	const { highDemandProducts } = useSelector((state) => state);

	const { RemoveHighDemandMessaging } = useSelector(
		(state) => state.experimentSwitches
	);

	return (
		!RemoveHighDemandMessaging &&
		currentProduct.State !== 'OutOfStock' &&
		highDemandProducts?.includes(currentProduct.ColourId)
	);
}
